(() => {
  if (window.lvCommerceBound) return;
  window.lvCommerceBound = true;
  let cartBusy = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const updateQuantity = async (input, quantity) => {
    if (cartBusy) return;
    const cart = input.closest('[data-lv-cart]');
    const error = cart?.querySelector('[data-lv-cart-error]');
    if (!cart) return;
    if (!Number.isSafeInteger(quantity) || quantity < 0) {
      input.value = input.defaultValue;
      if (error) { error.textContent = 'Enter a whole number of items, zero or more.'; error.hidden = false; }
      return;
    }
    cartBusy = true;
    cart.setAttribute('aria-busy', 'true');
    const controls = [...cart.querySelectorAll('button, input')];
    controls.forEach(control => { control.dataset.lvWasDisabled = String(control.disabled); control.disabled = true; });
    if (error) { error.hidden = true; error.textContent = ''; }
    try {
      const response = await fetch(root() + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: input.dataset.key, quantity }),
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Unable to update your cart. Please try again.');
      // Reload the native cart document so Shopify renders all discounts, totals,
      // line keys and header count from the same persisted session.
      window.location.reload();
    } catch (exception) {
      input.value = input.defaultValue;
      if (error) { error.textContent = exception.message || 'Unable to update your cart. Please try again.'; error.hidden = false; }
      controls.forEach(control => { control.disabled = control.dataset.lvWasDisabled === 'true'; delete control.dataset.lvWasDisabled; });
      cart.removeAttribute('aria-busy');
      cartBusy = false;
    }
  };
  document.addEventListener('click', event => {
    const quantityButton = event.target.closest('[data-lv-quantity]');
    if (quantityButton) {
      const input = quantityButton.closest('.lv-quantity')?.querySelector('[data-lv-cart-quantity]');
      if (input) updateQuantity(input, Math.max(0, Number(input.value) + Number(quantityButton.dataset.lvQuantity)));
      return;
    }
    const remove = event.target.closest('[data-lv-remove]');
    if (remove) {
      event.preventDefault();
      const input = remove.closest('[data-line-key]')?.querySelector('[data-lv-cart-quantity]');
      if (input) updateQuantity(input, 0);
      return;
    }
    const filterToggle = event.target.closest('[data-lv-filter-toggle]');
    if (filterToggle) {
      const expanded = filterToggle.getAttribute('aria-expanded') !== 'true';
      filterToggle.setAttribute('aria-expanded', String(expanded));
      document.getElementById(filterToggle.getAttribute('aria-controls'))?.classList.toggle('is-open', expanded);
      return;
    }
    const gridButton = event.target.closest('[data-lv-grid]');
    if (gridButton) {
      const section = gridButton.closest('.lv-collection');
      section?.querySelector('.lv-product-grid')?.classList.toggle('lv-product-grid--compact', gridButton.dataset.lvGrid === 'compact');
      section?.querySelectorAll('[data-lv-grid]').forEach(button => button.setAttribute('aria-pressed', String(button === gridButton)));
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-lv-cart-quantity]')) updateQuantity(event.target, Number(event.target.value));
    if (event.target.matches('[data-lv-sort]')) event.target.form?.requestSubmit();
  });
})();
